import firebase from 'firebase'
//import firestore from 'firebase/firestore'

let config = {
    apiKey: "AIzaSyB1zzLqSJLMp12XKWjO7QmSihaQlbEhfX0",
    authDomain: "ezcall-a2a55.firebaseapp.com",
    databaseURL: "https://ezcall-a2a55.firebaseio.com",
    projectId: "ezcall-a2a55",
    storageBucket: "ezcall-a2a55.appspot.com",
    messagingSenderId: "497866219792"
};

const app = firebase.initializeApp(config)

app.firestore().settings({timestampsInSnapshots: true})

export const db = app.firestore()
